export default {
	name: "Français",

	'global.itemCounts': `{total, plural,
		=0 {pas de contenu}
		other {}
	}{collections, plural,
		=0 {}
		one {une collection}
		other {{collections} collections}
	}{both, select,
		true {, }
		other {}
	}{stories, plural,
		=0 {}
		one {une histoire}
		other {{stories} histoires}
	}`,

	'cover.stories': `{itemCount, plural,
		one {histoire}
		other {histoires}
	}`,

	'searchbutton.placeholder': 'recherche...',

	'flow.empty': 'Il n’y a aucun contenu à afficher ici.',

	'search.empty': 'Votre recherche n’a renvoyé aucun résultat.',

	'forms.submitted': 'Vos entrées ont été soumises avec succès.',
	'forms.errored': 'Une erreur s\'est produite lors de l\'envoi de vos entrées.',
	'forms.required': 'Ce champ est requis pour soumettre le formulaire.',
	'forms.close': 'merci',

	'prevnext.prev': 'histoire précédente',
	'prevnext.next': 'prochaine histoire',

	'navigation.back': 'dos',
	
	'share.back': 'dos',
	'share.embed': 'intégrer',
	'share.share': 'partager',
	'share.cover': 'couverture',
	'share.custom': 'élément personnalisé',
	'share.inline': 'intégration directe',
	'share.customhere': 'INSCRIRE VOTRE PROPRE ELEMENT ICI',
	'share.scriptonce': 'Le script ci-dessus doit être inclus une seule fois par page',
	'share.FacebookLabel': 'Partager sur Facebook',
	'share.TwitterLabel': 'Tweet',
	'share.TwitterText': '{title}',
	'share.EmbedLabel': 'intégrer',

	'more.showCollection': 'Afficher toutes les histoires',
	'more.showMore': 'Afficher des histoires anciennes',
	'more.showMoreBack': '«',
	'more.showMoreSearch': 'Afficher plus de contenus',
	'more.showMoreSearchBack': '«',

	'multislider.showAll': 'Afficher toutes les histoires',

	'passwordScreen.passwordPlaceholder': 'mot de passe',
	'passwordScreen.usernamePlaceholder': 'Nom d\'utilisateur',
	'passwordScreen.subTitle': 'est une {type, select, story {histoire} collection {collection}} protégée',
	'passwordScreen.submit': 'soumettre',
	'passwordScreen.error': 'autorisation impossible!',

	'like.label': 'Comme {likeCount, number}',
	'like.noLikeLabel': 'J\'aime ça',

    "forward.title": "Renvoi",
    "forward.message": "Vous êtes renvoyé vers: {href}",
};



// WEBPACK FOOTER //
// ./lib/locales/fr.js